import { fetchRegisterSenaoMembership } from '@/api/member-registration';
import { createFormDataFromOrderInfo, processRegisterResponse } from '@/helpers/handle-fetch-register';
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

export function useRegister(props, context) {
  /**
   * step1_驗證表單行為: 畫面捲動到未填或格式錯誤的 input & focus
   * @param {Object} errors - 驗證錯誤訊息
   */
  const focusErrorInput = function (errors) {
    const { msg } = errors.items[0];
    if (msg.length) {
      const thisErrorInputName = errors.items[0].field;
      const thisErrorInput = document.querySelector(`[name=${thisErrorInputName}]`) || null;
      if (thisErrorInput !== null) {
        thisErrorInput.scrollIntoView({ behavior: 'smooth' });
        thisErrorInput.focus();
      }
    }
  };

  const fetchRegister = () => {
    fetchRegisterSenaoMembership(createFormDataFromOrderInfo(false)).then((res) => {
      if (res.data.code === 0) {
        alert(res.data.description);
      } else {
        processRegisterResponse(res, context);
      }
    });
  };

  return {
    focusErrorInput,
    fetchRegister,
  };
}
